<template>
  <div class="security-pro">
    <security-num></security-num>
    <mirror-img></mirror-img>
  </div>
</template>
<!-- 安防 -->
<script>
import MirrorImg from "./components/mirror-img.vue";
import securityNum from "./components/security-num.vue";
export default {
  components: { securityNum, MirrorImg },
};
</script>
<style lang="scss" scoped>
.security-pro {
  position: absolute;
  right: 43px;
  top: 135px;
  width: 416px;
}
</style>
